import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "handDollarFilled"
const HandDollarFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M5.683 14.489C6.176 14.489 6.577 14.889 6.577 15.383V21.106C6.577 21.599 6.177 22 5.683 22H3.894C3.4 22 3 21.6 3 21.106V15.383C3 14.889 3.4 14.489 3.894 14.489zM11.763 14.488C12.935 14.488 13.928 15.24 14.293 16.287L14.183 16.357C13.44 16.772 12.6 16.992 11.748 16.992H11.406C11.109 16.993 10.869 17.232 10.869 17.529S11.109 18.066 11.406 18.066H11.747C12.787 18.066 13.811 17.797 14.717 17.287L14.728 17.282 14.738 17.275 18.198 15.12C18.7 14.807 19.297 14.74 19.835 14.899 20.067 15.027 20.278 15.205 20.436 15.443 20.76 15.927 20.721 16.476 20.566 16.916 20.412 17.354 20.122 17.756 19.808 18.046L17.285 20.39C16.17 21.424 14.705 22 13.183 22H12.303C11.414 22 10.531 21.856 9.688 21.575L7.65 20.896V15.41L8.773 14.848C9.245 14.612 9.765 14.488 10.293 14.488z" />
          <path
            fillRule="evenodd"
            d="M12.12 2C15.184 2 17.666 4.482 17.666 7.544S15.183 13.088 12.12 13.088 6.577 10.606 6.577 7.544 9.059 2 12.12 2M11.783 5.077C11.081 5.214 10.464 5.641 10.464 6.425 10.465 8.085 13.006 7.719 13.008 8.579 13.007 8.884 12.722 9.143 12.197 9.143 11.628 9.143 11.158 8.923 10.788 8.618L10.196 9.272C10.634 9.7 11.243 9.942 11.782 10.026V10.818H12.706V10.011C13.515 9.843 14.046 9.265 14.046 8.565 14.047 6.875 11.507 7.102 11.506 6.433 11.505 6.158 11.797 5.945 12.298 5.945 12.753 5.945 13.146 6.098 13.438 6.295L13.931 5.573C13.569 5.305 13.13 5.13 12.706 5.07V4.27H11.782z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default HandDollarFilledIcon
